import * as React from 'react';

import {gameRulesContainer, GameRulesContainerConfigurationContext} from './gameRulesContainerConfiguration';

const withGameRulesContainerConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <GameRulesContainerConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...gameRulesContainer}/>
                );
            }}
        </GameRulesContainerConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withGameRulesContainerConfiguration;